// import "./Cart.scss";
// import prod1 from "../Assets/prod1.webp";
// import returnIcon from "../Assets/returnIcon.svg";
// import rupeesIcon from "../Assets/rupeesIcon.svg";
// import couponIcon from "../Assets/couponIcon.svg";
// import { ItemsProgress } from "../../Components/Items-Progress/Mob/ItemsProgress";
// // import { ItemsProgress } from "../../Components/Items-Progress/ItemsProgress";

// export function MobCart() {
//   return (
//     <>
//       <ItemsProgress />

//       <div className="mob-base-cartLayout-mob">
//         <div className="itemBlock-base-leftBlock">
//           <div className="cartItemsList">
//             <div className="itemContainer-base-itemMargin">
//               <div className="itemContainer-base-item">
//                 <div className="itemContainer-base-itemLeft">
//                   <img src={prod1} />
//                 </div>

//                 <div className="itemContainer-base-itemRight">
//                   <div className="brand-and-seller">
//                     <div>Puma</div>
//                     <a>Ess Polo T-shirt</a>
//                   </div>

//                   <div className="itemComponents-base-sellerContainer">
//                     <div className="itemComponents-base-sellerData">
//                       Sold by: Puma Sports India Pvt. Ltd.(NSCM)
//                     </div>
//                   </div>

//                   <div className="itemContainer-base-sizeAndQtyContainer">
//                     <div className="itemContainer-base-sizeAndQty">
//                       <div className="itemComponents-base-size">
//                         <span>Size: M</span>
//                       </div>

//                       <div className="itemComponents-base-quantity">
//                         <span>Qty: 1</span>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="6"
//                           height="3"
//                           viewBox="0 0 6 3"
//                           class="itemComponents-base-dropDown"
//                         >
//                           <path fill-rule="evenodd" d="M0 0h6L3 3z"></path>
//                         </svg>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="itemContainer-base-price">
//                     <div>
//                       <span className="rupee-symbol" aria-hidden="true">₹</span>
//                       679
//                     </div>

//                     <div>
//                       <span>1,699</span>

//                       <span>60% OFF</span>
//                     </div>
//                   </div>

//                   <div className="returnPeriod-base-returnItem">
//                     <div className="returnPeriod-base-returnIcon">
//                       <img src={returnIcon} />
//                     </div>
//                     <div className="returnPeriod-base-returnText">
//                       <span>14 days </span>
//                       return available
//                     </div>
//                   </div>

//                   <div className="itemComponents-base-deliveryDateContainer">
//                     <div class="itemComponents-base-messageText itemComponents-base-message">
//                       <span>Delivery in </span>
//                       <span class="itemComponents-base-highlightedMessage ">
//                         2 days
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="itemContainer-base-itemMargin">
//               <div className="itemContainer-base-item">
//                 <div className="itemContainer-base-itemLeft">
//                   <img src={prod1} />
//                 </div>

//                 <div className="itemContainer-base-itemRight">
//                   <div className="brand-and-seller">
//                     <div>Puma</div>
//                     <a>Ess Polo T-shirt</a>
//                   </div>

//                   <div className="itemComponents-base-sellerContainer">
//                     <div className="itemComponents-base-sellerData">
//                       Sold by: Puma Sports India Pvt. Ltd.(NSCM)
//                     </div>
//                   </div>

//                   <div className="itemContainer-base-sizeAndQtyContainer">
//                     <div className="itemContainer-base-sizeAndQty">
//                       <div className="itemComponents-base-size">
//                         <span>Size: M</span>
//                       </div>

//                       <div className="itemComponents-base-quantity">
//                         <span>Qty: 1</span>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="6"
//                           height="3"
//                           viewBox="0 0 6 3"
//                           class="itemComponents-base-dropDown"
//                         >
//                           <path fill-rule="evenodd" d="M0 0h6L3 3z"></path>
//                         </svg>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="itemContainer-base-price">
//                     <div>
//                       <span className="rupee-symbol" aria-hidden="true">₹</span>
//                       679
//                     </div>

//                     <div>
//                       <span>1,699</span>

//                       <span>60% OFF</span>
//                     </div>
//                   </div>

//                   <div className="returnPeriod-base-returnItem">
//                     <div className="returnPeriod-base-returnIcon">
//                       <img src={returnIcon} />
//                     </div>
//                     <div className="returnPeriod-base-returnText">
//                       <span>14 days </span>
//                       return available
//                     </div>
//                   </div>

//                   <div className="itemComponents-base-deliveryDateContainer">
//                     <div class="itemComponents-base-messageText itemComponents-base-message">
//                       <span>Delivery in </span>
//                       <span class="itemComponents-base-highlightedMessage ">
//                         2 days
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="desktop-base-right">
//           <div className="innerFilterCart2">
//             <div>
//               <img src={couponIcon} />
//             </div>
//             {/* <div className="innerFilter2"> */}
//             <div className="cart-sort-sortBy">
//               Apply Coupon <span></span>
//               {/* <span></span> */}
//               <ul className="sort-list">
//                 <li>
//                   <label class="sort-label ">
//                     <input type="radio" value="recommended" />
//                     Recommended
//                   </label>
//                 </li>
//                 <li>
//                   <label class="sort-label ">
//                     <input type="radio" value="whatsNew" />
//                     What's New
//                   </label>
//                 </li>
//                 <li>
//                   <label class="sort-label ">
//                     <input type="radio" value="popularity" />
//                     Popularity
//                   </label>
//                 </li>
//                 <li>
//                   <label class="sort-label ">
//                     <input type="radio" value="betterDiscount" />
//                     Better Discount
//                   </label>
//                 </li>
//                 <li>
//                   <label class="sort-label ">
//                     <input type="radio" value="priceHighToLow" />
//                     Price: High To Low
//                   </label>
//                 </li>
//                 <li>
//                   <label class="sort-label ">
//                     <input type="radio" value="priceLowToHigh" />
//                     Price: Low To High
//                   </label>
//                 </li>
//                 <li>
//                   <label class="sort-label ">
//                     <input type="radio" value="customerRating" />
//                     Customer Rating
//                   </label>
//                 </li>
//               </ul>
//             </div>
//           </div>

//           <div class="priceBlock-base-container">
//             <div class="priceBlock-base-priceHeader">
//               PRICE DETAILS (9 Items)
//             </div>
//             <div class="priceBreakUp-base-orderSummary" id="priceBlock">
//               <div class="priceDetail-base-row ">
//                 <span class=" ">Total MRP</span>
//                 <span class="priceDetail-base-value ">
//                   <span></span>
//                   <span>
//                     {" "}
//                     <span class="">₹</span>14,791
//                   </span>
//                 </span>
//               </div>
//               <div class="priceDetail-base-row ">
//                 <span class=" ">Discount on MRP</span>
//                 <span class="priceDetail-base-value priceDetail-base-discount">
//                   <span>-</span>
//                   <span>
//                     {" "}
//                     <span class="">₹</span>4,680
//                   </span>
//                 </span>
//               </div>
//               <div class="priceDetail-base-row ">
//                 <span>Coupon Discount</span>
//                 <span class="priceDetail-base-value priceDetail-base-action">
//                   Apply Coupon
//                 </span>
//               </div>
//               <div class="priceDetail-base-row ">
//                 <span class=" ">
//                   Platform Fee
//                   <span class="priceDetail-base-knowMore ">Know More</span>
//                 </span>
//                 <span class="priceDetail-base-value">
//                   <span class="priceDetail-base-discount">FREE</span>
//                 </span>
//               </div>

//               {/* <div class="priceDetail-base-row ">
//                 <span class=" ">
//                   Shipping Fee
//                   <span class="priceDetail-base-knowMore ">Know More</span>
//                 </span>
//                 <span class="priceDetail-base-value">
//                   <span class="priceDetail-base-discount">FREE</span>
//                 </span>
//               </div> */}


//               <div class="priceDetail-base-row ">
//               <span class=" ">
//                   Shipping Fee
//                   <span class="priceDetail-base-knowMore ">Know More</span>
//                 </span>
//                 <span class="priceDetail-base-value">
//                   <span class="priceDetail-base-striked priceDetail-base-spaceRight">
//                     <span>₹79</span>
//                   </span>
//                   <span class="priceDetail-base-discount">FREE</span>
//                 </span>
//                 <div class="priceDetail-base-convenienceCalloutText">
//                   Free shipping for you
//                 </div>
//               </div>
//               <div class="priceDetail-base-total ">
//                 <span class=" ">Total Amount</span>
//                 <span class="priceDetail-base-value ">
//                   <span></span>
//                   <span>
//                     {" "}
//                     <span class="priceDetail-base-redesignRupeeTotalIcon">
//                       ₹
//                     </span>
//                     10,111
//                   </span>
//                 </span>
//               </div>
//             </div>
//           </div>

//           <div>
//             <button
//               width="100%"
//               letterspacing="1px"
//               font-weight="bold"
//               role="button"
//               class="css-ibwr57"
//             >
//               <div class="css-xjhrni">PLACE ORDER</div>
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }






import "./Cart.scss";
import { useNavigate } from "react-router-dom";
import returnIcon from "../Assets/returnIcon.svg";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from '../../config';
import selectSvg from '../Assets/select.svg';
import unselectSvg from '../Assets/unselect.svg';
import OverlayLoader from "../../Components/Loader/overlay_loader";
import deliveryIcon from '../Assets/delivery.svg';
import { useProfile } from "../../Contexts/ProfileContext";
import { useToast } from "../../Contexts/ToastContext";
import { showOrderErrorToast } from "../../utils/orderErrorMessage";
import { beginCheckoutSession } from "../../utils/orderSuccessSnapshot";
import { fetchCoupons, resolvePendingCoupon } from "../../utils/couponsApi";
import { getPreferredNotifyChannel } from "../../utils/notifyChannel";
import {
  getCartLineMaxStock,
  getStockForSize,
  getCartStockHint,
  isCartStockHintUrgent,
  nextCartQuantity,
  clampQtyToStock,
  partitionCartByStock,
} from "../cartQuantity";
import { LoadingStateCard } from "../../Components/LoadingStateCard/LoadingStateCard";
import { isMobile } from "react-device-detect";
import { useMobCheckoutLeaveConfirm, allowCheckoutStepTransition } from "../../hooks/useMobCheckoutLeaveConfirm";
import { MobCouponModal } from "../../Checkout/Mob/MobCouponModal";

export function MobCart() {

  const [cartData, setCartData] = useState([]);
  const [cartHasFetched, setCartHasFetched] = useState(false);
  const [selectedCarts, setSelectedCarts] = useState({});
  const [loading, setLoading] = useState(false);

  const [selectedSize, setSelectedSize] = useState({});
  const [selectedQty, setSelectedQty] = useState({});
  const [availableSizes, setAvailableSizes] = useState({});
  const [sizeDropdowns, setSizeDropdowns] = useState([]);
  const [sizeDropdownPositions, setSizeDropdownPositions] = useState({});
  const [confirmRemoveIndex, setConfirmRemoveIndex] = useState(null);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [availableCoupons, setAvailableCoupons] = useState([]);
  const navigate = useNavigate();
  const { fetchProfile } = useProfile();
  const { showToast } = useToast();

  const { LeaveConfirmModal } = useMobCheckoutLeaveConfirm(isMobile && loading, {
    // No progress to protect on an empty cart — allow immediate back/nav.
    enabled: cartHasFetched && cartData.length > 0,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const list = await fetchCoupons();
        if (cancelled) return;
        setAvailableCoupons(list);
        const pending = await resolvePendingCoupon(list);
        if (pending && !cancelled) setSelectedCoupon(pending);
      } catch (e) {
        console.error('Failed to load coupons:', e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleCouponSelect = (coupon) => {
    setSelectedCoupon(coupon);
    setShowCouponModal(false);
  };

  const handleRemoveCoupon = () => {
    setSelectedCoupon(null);
  };

  function couponDiscount() {
    if (!selectedCoupon) return 0;
    
    const total = cartData.reduce((prevVal, curObj, curIndex) => {
      if (selectedCarts[curIndex])
        return prevVal + (selectedQty[curIndex] || 1) * curObj.price
      return prevVal
    }, 0);

    if (selectedCoupon.type === 'percentage') {
      return Math.round(total * selectedCoupon.discount / 100);
    } else {
      return selectedCoupon.discount;
    }
  }

  const handleSizeDropdownToggle = (index, event) => {
    if (event) {
      event.stopPropagation();
    }
    let sizeDropdownsCopy = [...sizeDropdowns];
    const isOpening = !sizeDropdownsCopy[index];
    sizeDropdownsCopy[index] = isOpening;
    sizeDropdownsCopy = sizeDropdownsCopy.map((val, i) => i === index ? sizeDropdownsCopy[index] : false);
    setSizeDropdowns(sizeDropdownsCopy);

    if (isOpening && event) {
      const button = event.currentTarget;
      requestAnimationFrame(() => {
        const rect = button.getBoundingClientRect();
        setSizeDropdownPositions(prev => ({
          ...prev,
          [index]: {
            top: rect.bottom + 4,
            left: rect.left,
            width: rect.width
          }
        }));
      });
    } else {
      setSizeDropdownPositions(prev => {
        const newPositions = { ...prev };
        delete newPositions[index];
        return newPositions;
      });
    }
  };

  const handleSizeSelect = async (size, index) => {
    const cartItem = cartData[index];
    const sizeStock = getStockForSize(cartItem, size);
    const sizeDropdownsCopy = [...sizeDropdowns];
    sizeDropdownsCopy[index] = false;
    setSizeDropdowns(sizeDropdownsCopy);

    if (sizeStock <= 0) {
      await removeCartItem(index);
      return;
    }

    setSelectedSize({ ...selectedSize, [index]: size });
    const maxQuantity = getCartLineMaxStock(cartItem, size);
    const currentQty = selectedQty[index] || 1;
    if (currentQty > maxQuantity) {
      setSelectedQty({ ...selectedQty, [index]: clampQtyToStock(currentQty, maxQuantity) });
    }
  };

  const handleQuantityChange = (index, change) => {
    const sizeKey = selectedSize?.[index] ?? cartData[index]?.selectedSize;
    const maxStock = getCartLineMaxStock(cartData[index], sizeKey);
    const { nextQty, removeItem } = nextCartQuantity(selectedQty?.[index], change, maxStock);
    if (removeItem) {
      setConfirmRemoveIndex(index);
      return;
    }
    setSelectedQty({ ...selectedQty, [index]: nextQty });
  };

  const handleMinusClick = (index) => {
    const currentQty = selectedQty?.[index] || 1;
    if (currentQty <= 1) {
      setConfirmRemoveIndex(index);
      return;
    }
    handleQuantityChange(index, -1);
  };

  async function fetchCarts() {
    try {
      const isGuest = localStorage.getItem('guestUser') === 'true';
      if (isGuest) {
        const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
        const { inStock: guestInStock, outOfStock: guestOos } = partitionCartByStock(guestCart);
        if (guestOos.length > 0) {
          localStorage.setItem('guestCart', JSON.stringify(guestInStock));
          window.dispatchEvent(new CustomEvent('guestCartUpdated'));
          showToast({
            message:
              guestOos.length === 1
                ? 'An out-of-stock item was removed from your cart.'
                : `${guestOos.length} out-of-stock items were removed from your cart.`,
          });
        }
        const processedData = guestInStock.map((cartItem) => {
          const productSizes = cartItem.size || {};
          return {
            ...cartItem,
            availableSizes: Object.keys(productSizes).filter((size) => productSizes[size] > 0),
          };
        });
        setCartData(processedData);
        const cartsObj = {};
        const sizesObj = {};
        const quantitiesObj = {};
        const availableSizesObj = {};
        processedData.forEach((cart, index) => {
          cartsObj[index] = true;
          sizesObj[index] = cart.selectedSize;
          quantitiesObj[index] = clampQtyToStock(cart.selectedQty, getCartLineMaxStock(cart, cart.selectedSize));
          availableSizesObj[index] = cart.availableSizes;
        });
        setSelectedCarts(cartsObj);
        setSelectedSize(sizesObj);
        setSelectedQty(quantitiesObj);
        setAvailableSizes(availableSizesObj);
        setSizeDropdowns(new Array(processedData.length).fill(false));
        setCartHasFetched(true);
        return;
      }

      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      const response = await axios.get(
        `/cart/get-all`,
        config
      );

      let data = response.data || [];
      console.log('fetchCarts response data - ', data);

      const cartList = Array.isArray(data) ? data : [];
      const { inStock, outOfStock } = partitionCartByStock(cartList);

      if (outOfStock.length > 0) {
        await Promise.all(
          outOfStock.map((item) =>
            item._id
              ? axios.delete('/cart/delete', {
                  data: { cartId: item._id },
                  headers: config.headers,
                })
              : Promise.resolve()
          )
        );
        try {
          await fetchProfile();
        } catch (profileError) {
          console.error('Failed to refetch profile after OOS removal:', profileError);
        }
        showToast({
          message:
            outOfStock.length === 1
              ? 'An out-of-stock item was removed from your cart.'
              : `${outOfStock.length} out-of-stock items were removed from your cart.`,
        });
      }

      const processedData = inStock.map((cartItem) => {
        const productSizes = cartItem.size || {};
        return {
          ...cartItem,
          availableSizes: Object.keys(productSizes).filter((size) => productSizes[size] > 0),
        };
      });

      setCartData(processedData);

      const cartsObj = {};
      const sizesObj = {};
      const quantitiesObj = {};
      const availableSizesObj = {};

      processedData.forEach((cart, index) => {
        cartsObj[index] = true;
        sizesObj[index] = cart.selectedSize;
        quantitiesObj[index] = clampQtyToStock(cart.selectedQty, getCartLineMaxStock(cart, cart.selectedSize));
        availableSizesObj[index] = cart.availableSizes;
      });

      setSelectedCarts(cartsObj);
      setSelectedSize(sizesObj);
      setSelectedQty(quantitiesObj);
      setAvailableSizes(availableSizesObj);
      setSizeDropdowns(new Array(processedData.length).fill(false));
    }
    catch (error) {
      console.error("Failed to fetch products:", error);
      setCartData([]);
    }
    finally {
      setCartHasFetched(true);
    }
  }

  function updateSelectedCarts(index) {
    setSelectedCarts({ ...selectedCarts, [index]: !selectedCarts[index] })
  }

  // Remove item from cart (confirmation-approved)
  const removeCartItem = async (index) => {
    try {
      const isGuest = localStorage.getItem('guestUser') === 'true';
      if (isGuest) {
        const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
        guestCart.splice(index, 1);
        localStorage.setItem('guestCart', JSON.stringify(guestCart));
        window.dispatchEvent(new CustomEvent('guestCartUpdated'));
        await fetchCarts();
        setConfirmRemoveIndex(null);
        return;
      }

      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      
      const cartId = cartData[index]?._id;
      if (!cartId) {
        console.error('Cart ID not found for index:', index);
        showToast({ message: 'Could not find cart item to delete' });
        setConfirmRemoveIndex(null);
        return;
      }

      const response = await axios.delete(
        `/cart/delete`,
        {
          data: { cartId },
          headers: config.headers
        }
      );

      console.log('Cart item deleted:', response.data);
      
      await fetchCarts();
      try {
        await fetchProfile();
      } catch (profileError) {
        console.error('Failed to refetch profile data:', profileError);
      }
      
    } catch (error) {
      console.error('Failed to remove cart item:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to remove item from cart';
      showToast({ message: errorMessage });
    } finally {
      setConfirmRemoveIndex(null);
    }
  };

  async function placeOrder() {
    console.log('in placeOrder');
    const isGuest = localStorage.getItem('guestUser') === 'true';

    const orderItems = []
    let totalMRP = 0
    let totalDiscount = 0
    let totalAmount = 0
    let itemCount = 0

    Object.keys(selectedCarts).forEach((key) => {
      if (selectedCarts[key]) {
        const cartItem = cartData[key]
        const quantity = selectedQty[key]
        const size = selectedSize[key]
        const orderItem = {
          product_id: cartItem.product_id,
          selectedSize: size,
          selectedQty: quantity,
          unit_price: cartItem.price,
          unit_mrp: cartItem.mrp,
          total_price: cartItem.price * quantity,
          total_mrp: cartItem.mrp * quantity,
          discount_amount: (cartItem.mrp - cartItem.price) * quantity,
          product_title: cartItem.title,
          product_data: { title: cartItem.title, urls: cartItem.urls || [] }
        }
        orderItems.push(orderItem)
        totalMRP += cartItem.mrp * quantity
        totalDiscount += (cartItem.mrp - cartItem.price) * quantity
        totalAmount += cartItem.price * quantity
        itemCount += quantity
      }
    })

    let couponDiscountAmount = 0;
    if (selectedCoupon) {
      if (selectedCoupon.type === 'percentage') {
        couponDiscountAmount = Math.round(totalAmount * selectedCoupon.discount / 100);
      } else {
        couponDiscountAmount = selectedCoupon.discount;
      }
    }
    const finalAmount = totalAmount - couponDiscountAmount

    const notification_channel = getPreferredNotifyChannel();
    const orderData = {
      order_items: orderItems,
      order_summary: {
        item_count: itemCount,
        total_mrp: totalMRP,
        total_discount: totalDiscount,
        coupon_discount: couponDiscountAmount,
        shipping_fee: 0,
        final_amount: finalAmount
      },
      coupon_code: selectedCoupon ? selectedCoupon.code : "",
      use_store_credit: false,
      ...(notification_channel && { notification_channel }),
    }

    if (isGuest) {
      const guestCheckoutData = { ...orderData, selectedCoupon: selectedCoupon || null };
      localStorage.setItem('guestCheckoutData', JSON.stringify(guestCheckoutData));
      beginCheckoutSession();
      allowCheckoutStepTransition();
      navigate('/order-summary');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      console.log('Comprehensive order data:', orderData);

      const response = await axios.post(
        `/orders/create`,
        orderData,
        config
      );

      let data = response.data;
      console.log('Order creation response:', data);

      // Backend returns only order header (no order_items). Save order summary page data with our order_items (they include product_data for images).
      if (data.order) {
        const orderToSave = {
          ...data.order,
          order_items: orderData.order_items || []
        };
        localStorage.setItem('latestOrder', JSON.stringify(orderToSave));
      }

      // Navigate only on success (removed alert for better UX)
      beginCheckoutSession();
      allowCheckoutStepTransition();
      navigate('/order-summary');

    }
    catch (error) {
      console.log('Error creating order:', error);
      console.log('Error details:', error.response?.data);
      showOrderErrorToast(showToast, error, 'Failed to place order. Please try again.');
    }
    finally {
      setLoading(false); // Hide loader
    }

  }



  useEffect(() => {
    fetchCarts()
  }, [])

  useEffect(() => {
    const updateDropdownPositions = () => {
      sizeDropdowns.forEach((isOpen, index) => {
        if (!isOpen) return;
        const button = document.querySelector(`.cart-select[data-dropdown-index="${index}"][data-dropdown-type="size"]`);
        if (!button) return;
        const rect = button.getBoundingClientRect();
        setSizeDropdownPositions(prev => ({
          ...prev,
          [index]: {
            top: rect.bottom + 4,
            left: rect.left,
            width: rect.width
          }
        }));
      });
    };

    const handleScroll = () => updateDropdownPositions();
    const handleResize = () => updateDropdownPositions();

    window.addEventListener('scroll', handleScroll, { passive: true, capture: true });
    window.addEventListener('resize', handleResize);

    const cartContainer = document.querySelector('.mob-base-cartLayout-mob');
    if (cartContainer) {
      cartContainer.addEventListener('scroll', handleScroll, { passive: true });
    }

    return () => {
      window.removeEventListener('scroll', handleScroll, { capture: true });
      window.removeEventListener('resize', handleResize);
      if (cartContainer) {
        cartContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [sizeDropdowns]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickInsideDropdown = event.target.closest('.cart-select') ||
                                     event.target.closest('.dropdown-menu');

      if (!isClickInsideDropdown) {
        setSizeDropdowns(new Array(sizeDropdowns.length).fill(false));
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sizeDropdowns.length])

  if (!cartHasFetched) {
    return (
      <>
        <LoadingStateCard message="Loading cart..." />
        {LeaveConfirmModal}
      </>
    );
  }

  if (cartData.length === 0) {
    return (
      <>
        <div className="mob-base-cartLayout-mob">
          <div className="empty-cart-container">
            <div className="empty-cart-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
            </div>
            <h2 className="empty-cart-title">No items added in cart</h2>
            <p className="empty-cart-message">Your cart is empty. Start shopping to add items!</p>
            <button
              className="empty-cart-button"
              onClick={() => navigate('/')}
            >
              Continue Shopping
            </button>
          </div>
        </div>
        {LeaveConfirmModal}
      </>
    );
  }

  return (
    <>
      <div className="mob-base-cartLayout-mob">
        <div className="itemBlock-base-leftBlock">
          <div className="cartItemsList">
            {cartData.map((cart, index) => {
                const sizeKey = selectedSize?.[index] ?? cart?.selectedSize;
                const currentQty = selectedQty?.[index] || 1;
                const stockHint = getCartStockHint(cart, sizeKey, currentQty);
                const stockHintUrgent = isCartStockHintUrgent(cart, sizeKey, currentQty);
                const lineMaxQty = getCartLineMaxStock(cart, sizeKey);
                return (
                  <div key={index} className="itemContainer-base-itemMargin">
                <div className="itemContainer-base-item">
                  <div className="itemContainer-base-itemLeft">
                    <div className="itemComponents-base-selectionIconContainer">
                      <div className="itemComponents-base-animationContainer">
                        <img src={selectedCarts[index] === true ? selectSvg : unselectSvg} className="itemComponents-base-activeProduct " onClick={() => updateSelectedCarts(index)} />
                      </div>
                    </div>
                    <img src={cart?.urls?.[1] || cart?.urls?.[0] ? (String(cart.urls[1] || cart.urls[0]).startsWith('http') ? (cart.urls[1] || cart.urls[0]) : `${API_BASE_URL}/${(cart.urls[1] || cart.urls[0]).replace(/^\//, '')}`) : ''} alt="" />
                  </div>

                  <div className="itemContainer-base-itemRight">
                    <button 
                      className="cart-item-delete-btn"
                      onClick={() => setConfirmRemoveIndex(index)}
                      title="Remove item from cart"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                    <div className="brand-and-seller">
                      <div>{cart?.brand}</div>
                      <a>{cart?.title}</a>
                    </div>

                    <div className="itemComponents-base-sellerContainer">
                      <div className="itemComponents-base-sellerData">
                        Sold by: Puma Sports India Pvt. Ltd.(NSCM)
                      </div>
                    </div>

                    <div className="itemContainer-base-price">
                      <div className="price-current">
                        <span className="rupee-symbol" aria-hidden="true">₹</span>
                        {cart?.price?.toLocaleString('en-IN')}
                      </div>

                      <div className="price-details">
                        <span className="price-mrp">₹{cart?.mrp?.toLocaleString('en-IN')}</span>
                        <span className="price-discount">
                          {cart?.mrp && cart?.price ? Math.round(((cart.mrp - cart.price) / cart.mrp) * 100) : 0}% OFF
                        </span>
                      </div>
                    </div>

                    <div className="itemContainer-base-sizeAndQtyContainer">
                      <div className="itemContainer-base-sizeAndQty">
                        {/* <div className="itemComponents-base-size">
                          <span>
                            <div>Size: </div><div className="cart-select">{cart?.selectedSize}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="6"
                                height="3"
                                viewBox="0 0 6 3"
                                stroke="currentColor" fill="currentColor"
                                class="itemComponents-base-dropDown"
                              >
                                <path fill-rule="evenodd" d="M0 0h6L3 3z"></path>
                              </svg>
                            </div>
                          </span>
                        </div> */}

                        <div className="itemComponents-base-size">
                          <span>
                            <div className="size-label">Size:</div>
                            <div
                              className={`cart-select ${sizeDropdowns?.[index] ? 'open' : ''}`}
                              data-dropdown-index={index}
                              data-dropdown-type="size"
                              onClick={(e) => handleSizeDropdownToggle(index, e)}
                            >
                              {selectedSize?.[index] || 'Select'}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="8"
                                height="6"
                                viewBox="0 0 8 6"
                                fill="none"
                                className={`itemComponents-base-dropDown ${sizeDropdowns?.[index] ? 'open' : ''}`}
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 0L4 6L8 0H0Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                            {sizeDropdowns?.[index] && sizeDropdownPositions[index] && (
                              <ul 
                                className="dropdown-menu"
                                style={{
                                  position: 'fixed',
                                  top: `${sizeDropdownPositions[index].top}px`,
                                  left: `${sizeDropdownPositions[index].left}px`,
                                  minWidth: `${sizeDropdownPositions[index].width}px`
                                }}
                              >
                                {availableSizes?.[index]?.map((size, sizeIndex) => (
                                  <li
                                    key={sizeIndex}
                                    className={`dropdown-item ${selectedSize?.[index] === size ? 'selected' : ''}`}
                                    onClick={() => handleSizeSelect(size, index)}
                                  >
                                    {size}
                                  </li>
                                ))}
                              </ul>
                            )}
                            {/* {sizeDropdowns?.[index] && (
                              <ul className="dropdown-menu">
                                {availableSizes?.[index]?.map((size, sizeIndex) => (
                                  <li
                                    key={sizeIndex}
                                    className="dropdown-item"
                                    onClick={() => handleSizeSelect(size, index)}
                                  >
                                    {size}
                                  </li>
                                ))}
                              </ul>
                            )} */}
                          </span>
                        </div>

                        <div className="itemComponents-base-size itemComponents-base-qtyBlock">
                          <span className="cart-qty-row">
                            <div className="qty-label">Qty:</div>
                            <div className="quantity-controls">
                              <button
                                type="button"
                                className="quantity-btn minus-btn"
                                onClick={() => handleMinusClick(index)}
                              >
                                -
                              </button>
                              <span className="quantity-value">{selectedQty?.[index] || 1}</span>
                              <button
                                type="button"
                                className="quantity-btn plus-btn"
                                onClick={() => handleQuantityChange(index, 1)}
                                disabled={(selectedQty?.[index] || 1) >= lineMaxQty}
                              >
                                +
                              </button>
                            </div>
                            {stockHint && (
                              <span
                                className={`cart-low-stock-indicator${stockHintUrgent ? ' cart-low-stock-indicator--urgent' : ''}`}
                                role="status"
                              >
                                {stockHint}
                              </span>
                            )}
                          </span>
                        </div>

                      </div>
                    </div>



                    <div className="return-delivery-row">
                      <div className="returnPeriod-base-returnItem">
                        <div className="returnPeriod-base-returnIcon">
                          <img src={returnIcon} alt="Return" />
                        </div>
                        <div className="returnPeriod-base-returnText">
                          <span  style={{marginRight: '4px'}}>14 days </span>
                          return available
                        </div>
                      </div>

                      <div className="returnPeriod-base-returnItem">
                        <div className="returnPeriod-base-returnIcon">
                          <img src={deliveryIcon} alt="Delivery" />
                        </div>
                        <div className="returnPeriod-base-returnText">
                          Delivery in
                          <span style={{marginLeft: '4px'}}> 2 days </span>
                        </div>
                      </div>
                    </div>

                    {/* <div className="itemComponents-base-deliveryDateContainer">
                      <div class="itemComponents-base-messageText itemComponents-base-message">
                        <span>Delivery in </span>
                        <span class="itemComponents-base-highlightedMessage ">
                          2 days
                        </span>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              )
              })}

            {/* <div className="itemContainer-base-itemMargin">
              <div className="itemContainer-base-item">
                <div className="itemContainer-base-itemLeft">
                <div className="itemComponents-base-selectionIconContainer">
                      <div className="itemComponents-base-animationContainer">
                        <img src={unselectSvg} className="itemComponents-base-activeProduct "/>
                      </div>
                    </div>
                  <img src={prod1} />
                </div>

                <div className="itemContainer-base-itemRight">
                  <div className="brand-and-seller">
                    <div>Puma</div>
                    <a>Ess Polo T-shirt</a>
                  </div>

                  <div className="itemComponents-base-sellerContainer">
                    <div className="itemComponents-base-sellerData">
                      Sold by: Puma Sports India Pvt. Ltd.(NSCM)
                    </div>
                  </div>

                  <div className="itemContainer-base-sizeAndQtyContainer">
                    <div className="itemContainer-base-sizeAndQty">
                      <div className="itemComponents-base-size">
                        <span>Size: M</span>
                      </div>

                      <div className="itemComponents-base-quantity">
                        <span>Qty: 1</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="6"
                          height="3"
                          viewBox="0 0 6 3"
                          class="itemComponents-base-dropDown"
                        >
                          <path fill-rule="evenodd" d="M0 0h6L3 3z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="itemContainer-base-price">
                    <div>
                      <span className="rupee-symbol" aria-hidden="true">₹</span>
                      679
                    </div>

                    <div>
                      <span>1,699</span>

                      <span>60% OFF</span>
                    </div>
                  </div>

                  <div className="returnPeriod-base-returnItem">
                    <div className="returnPeriod-base-returnIcon">
                      <img src={returnIcon} />
                    </div>
                    <div className="returnPeriod-base-returnText">
                      <span>14 days </span>
                      return available
                    </div>
                  </div>

                  <div className="itemComponents-base-deliveryDateContainer">
                    <div class="itemComponents-base-messageText itemComponents-base-message">
                      <span>Delivery in </span>
                      <span class="itemComponents-base-highlightedMessage ">
                        2 days
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="itemContainer-base-itemMargin">
              <div className="itemContainer-base-item">
                <div className="itemContainer-base-itemLeft">
                  <img src={prod1} />
                </div>

                <div className="itemContainer-base-itemRight">
                  <div className="brand-and-seller">
                    <div>Puma</div>
                    <a>Ess Polo T-shirt</a>
                  </div>

                  <div className="itemComponents-base-sellerContainer">
                    <div className="itemComponents-base-sellerData">
                      Sold by: Puma Sports India Pvt. Ltd.(NSCM)
                    </div>
                  </div>

                  <div className="itemContainer-base-sizeAndQtyContainer">
                    <div className="itemContainer-base-sizeAndQty">
                      <div className="itemComponents-base-size">
                        <span>Size: M</span>
                      </div>

                      <div className="itemComponents-base-quantity">
                        <span>Qty: 1</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="6"
                          height="3"
                          viewBox="0 0 6 3"
                          class="itemComponents-base-dropDown"
                        >
                          <path fill-rule="evenodd" d="M0 0h6L3 3z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="itemContainer-base-price">
                    <div>
                      <span className="rupee-symbol" aria-hidden="true">₹</span>
                      679
                    </div>

                    <div>
                      <span>1,699</span>

                      <span>60% OFF</span>
                    </div>
                  </div>

                  <div className="returnPeriod-base-returnItem">
                    <div className="returnPeriod-base-returnIcon">
                      <img src={returnIcon} />
                    </div>
                    <div className="returnPeriod-base-returnText">
                      <span>14 days </span>
                      return available
                    </div>
                  </div>

                  <div className="itemComponents-base-deliveryDateContainer">
                    <div class="itemComponents-base-messageText itemComponents-base-message">
                      <span>Delivery in </span>
                      <span class="itemComponents-base-highlightedMessage ">
                        2 days
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {cartData.length > 0 && (
          <div className="mobile-cart-summary">
            <div className="mobile-cart-summary-card">
              <h2 className="summary-title">
                Price Details
                <span className="summary-title-count">
                  ({(() => {
                    const count = cartData.reduce((sum, cart, index) => (
                      selectedCarts[index] ? sum + (selectedQty[index] || 1) : sum
                    ), 0);
                    return `${count} ${count === 1 ? 'item' : 'items'}`;
                  })()})
                </span>
              </h2>

              {cartData.filter((cart, index) => selectedCarts[index]).length > 0 && (
                <div className="order-items">
                  {cartData.map((cart, index) => {
                    if (!selectedCarts[index]) return null;
                    const qty = selectedQty[index] || 1;
                    const size = selectedSize[index] || cart.selectedSize;
                    const totalPrice = cart.price * qty;
                    const rawImg = cart?.urls?.[1] || cart?.urls?.[0];
                    const productImage = rawImg
                      ? (String(rawImg).startsWith('http')
                          ? rawImg
                          : `${API_BASE_URL}/${String(rawImg).replace(/^\//, '')}`)
                      : null;

                    return (
                      <div key={index} className="order-item">
                        {productImage && (
                          <div className="order-item-image">
                            <img src={productImage} alt={cart?.title || 'Product'} />
                          </div>
                        )}
                        <div className="order-item-main">
                          <div className="order-item-top">
                            <div className="order-item-name">
                              {cart?.title || 'Product'}
                            </div>
                            <div className="order-item-price">
                              ₹{totalPrice.toLocaleString('en-IN')}
                            </div>
                          </div>
                          <div className="order-item-meta">
                            <span className="order-item-size">Size: {size}</span>
                            <span className="order-item-qty">Qty: {qty}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              
              <div className="summary-totals">
                <div className="summary-row">
                  <span className="summary-label">Total MRP</span>
                  <span className="summary-value">
                    ₹{cartData.reduce((prevVal, curObj, curIndex) => {
                      if (selectedCarts[curIndex])
                        return prevVal + ((selectedQty[curIndex] || 1) * curObj.mrp)
                      return prevVal
                    }, 0).toLocaleString('en-IN')}
                  </span>
                </div>
                
                <div className="summary-row discount">
                  <span className="summary-label">Discount</span>
                  <span className="summary-value discount">
                    - ₹{cartData.reduce((prevVal, curObj, curIndex) => {
                      if (selectedCarts[curIndex])
                        return prevVal + ((selectedQty[curIndex] || 1) * (curObj.mrp - curObj.price))
                      return prevVal
                    }, 0).toLocaleString('en-IN')}
                  </span>
                </div>
                
                <div className="summary-row coupon-row">
                  <span className="summary-label">Coupon</span>
                  <div className="coupon-actions">
                    {selectedCoupon ? (
                      <div className="applied-coupon">
                        <span className="coupon-code">{selectedCoupon.code}</span>
                        <button 
                          className="remove-coupon-btn"
                          onClick={handleRemoveCoupon}
                          title="Remove coupon"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                            <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                          </svg>
                        </button>
                      </div>
                    ) : (
                      <button 
                        className="avail-coupon-btn"
                        onClick={() => setShowCouponModal(true)}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M8 3.5V12.5M3.5 8H12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        Avail Coupon
                      </button>
                    )}
                  </div>
                </div>
                {selectedCoupon && (
                  <div className="summary-row discount">
                    <span className="summary-label">Coupon Discount</span>
                    <span className="summary-value discount">
                      - ₹{couponDiscount().toLocaleString('en-IN')}
                    </span>
                  </div>
                )}
                
                <div className="summary-row shipping">
                  <span className="summary-label">Shipping</span>
                  <span className="summary-value free">FREE</span>
                </div>
                
                <div className="summary-row total">
                  <span className="summary-label">Total Amount</span>
                  <span className="summary-value total">
                    ₹{(cartData.reduce((prevVal, curObj, curIndex) => {
                      if (selectedCarts[curIndex])
                        return prevVal + ((selectedQty[curIndex] || 1) * curObj.price)
                      return prevVal
                    }, 0) - couponDiscount()).toLocaleString('en-IN')}
                  </span>
                </div>
              </div>

              <div className="place-order-footer">
                <button 
                  className="place-order-btn"
                  onClick={placeOrder}
                  disabled={loading || cartData.length === 0}
                >
                  {loading ? 'PROCESSING...' : 'PLACE ORDER'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div >

      {loading && <OverlayLoader />}
      {LeaveConfirmModal}

      {/* Remove Confirmation Modal */}
      {confirmRemoveIndex !== null && (
        <div className="remove-confirmation-modal">
          <div className="remove-confirmation-content">
            <h3>Remove Item?</h3>
            <p>Are you sure you want to remove this item from your cart?</p>
            <div className="remove-confirmation-buttons">
              <button 
                onClick={() => setConfirmRemoveIndex(null)}
                className="cancel-btn"
              >
                Cancel
              </button>
              <button 
                onClick={() => removeCartItem(confirmRemoveIndex)}
                className="remove-btn"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      )}

      <MobCouponModal
        open={showCouponModal}
        onClose={() => setShowCouponModal(false)}
        coupons={availableCoupons}
        selectedCoupon={selectedCoupon}
        onSelect={handleCouponSelect}
        orderTotal={cartData.reduce((prevVal, curObj, curIndex) => {
          if (selectedCarts[curIndex]) return prevVal + (selectedQty[curIndex] || 1) * curObj.price;
          return prevVal;
        }, 0)}
      />
    </>
  );
}
